export enum InfoStepEnum {
  QUESTIONNAIRE = 'questionnaire',
  PRESCRIPTION = 'prescription',
  DOCTOR = 'doctor',
  PHARMACY = 'pharmacy',
  HEALTH_QUESTION = 'healthQuestion',
  CURRENT_PLAN = 'currentPlan',
  COMPLETED = 'completed',
}
